import { If } from "components";
import { t } from "i18next";
import { ContentLayout, BoxShadowLayout } from "layouts";
import { SubChildCategory } from "modules/categories";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";

import {
  CategoriesBreadCrumbs,
  ProductDetailsForm,
  ProductDetailsFormCategoryAttributes
} from "../../components";
import { EMPTY_PRODUCT_FORM_VALUES } from "../../constants";
import { getEditableProductFormValues } from "../../helpers";
import { useProductDetailsCategory } from "../../hooks";
import { ProductDetailsProps } from "./ProductDetails.types";

import styles from "./ProductDetails.module.scss";

const ProductDetails = ({
  editableProduct,
  isEditableProductLoading
}: ProductDetailsProps) => {
  const { subChildCategoryId, editableProductId } = useParams();
  const { category, categoryAttributes, isLoading } = useProductDetailsCategory(
    String(subChildCategoryId)
  );

  const productFormDefaultValues = useMemo(() => {
    return editableProduct && categoryAttributes
      ? getEditableProductFormValues(
          editableProduct,
          categoryAttributes as ProductDetailsFormCategoryAttributes
        )
      : EMPTY_PRODUCT_FORM_VALUES;
  }, [editableProduct, categoryAttributes]);

  return (
    <ContentLayout title={t("Product Details")}>
      <BoxShadowLayout>
        <If condition={isLoading || !!isEditableProductLoading}>
          <div className={styles.productDetails_loader}>
            <ClipLoader size={30} color="#fb3973" />
          </div>
        </If>

        <If condition={category}>
          <CategoriesBreadCrumbs category={category as SubChildCategory} />
        </If>

        <If
          condition={
            categoryAttributes && (!editableProductId || editableProduct)
          }
        >
          <ProductDetailsForm
            categoryAttributes={
              categoryAttributes as ProductDetailsFormCategoryAttributes
            }
            defaultValues={productFormDefaultValues}
          />
        </If>
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default ProductDetails;
